import React from 'react';
import { useAppSelector } from '@/redux/hooks';
import { Frames } from '@/redux/slices/packagingSlice.types';
import DurationWrapper from '@/components/Packaging/LayeredTimeline/overlays/duration/DurationWrapper';
import { getSMPTETimecode } from '@/components/Packaging/utils';
import IconStyled from '@/components/Packaging/LayeredTimeline/overlays/duration/IconStyled';
import { selectPackagingTimelineFrameRate } from '@/redux/selectors/packagingSelectors';
import IconButton from '@/components/Packaging/common/IconButton';

interface Props {
  color: string;
  duration: Frames;
  hideEditButton: boolean;
  hasAssignedInventory: boolean;
  className?: string;
  onEditButtonClick(): void;
}

const DurationView: React.FC<Props> = ({ color, duration, hideEditButton, hasAssignedInventory, className, onEditButtonClick }) => {
  const frameRate = useAppSelector(selectPackagingTimelineFrameRate);

  return (
    <DurationWrapper className={className} color={color} hasAssignedInventory={hasAssignedInventory}>
      <span>{getSMPTETimecode(duration, frameRate)}</span>
      {!hideEditButton && (
        <IconButton title="Edit timecode" onClick={onEditButtonClick}>
          <IconStyled icon="edit" width={8} height={8} />
        </IconButton>
      )}
    </DurationWrapper>
  );
};

export default DurationView;
